module.exports = __webpack_public_path__ + "img/iconoApp.78002cfc.png";